import React from 'react';
import { BlockStack, Box, Button, Text } from '@shopify/polaris';
import { ExternalIcon } from '@shopify/polaris-icons';

function ShopifyOnboardStep2({ themeId, translate: lng }) {
  const shopName = sessionStorage.getItem('shop_name');
  const theme = themeId && themeId !== '0' ? themeId : 'current';
  const embedUrl = `https://${shopName}/admin/themes/${theme}/editor?context=apps&activateAppId=98f78e65-6b3d-4305-9b6d-7d8650f1a727/pixel&target=newAppsSection`;

  return (
    <div className='shopify-onboard-step2-wrap'>
      <div className='shopify-onboard-step2-card'>
        <div className='shopify-onboard-step2-image'>
          <img src="/images/shopify-embed-preview.svg" alt="Shopify Theme Editor" />
        </div>
        <div className='shopify-onboard-step2-form'>
          <BlockStack gap={400}>
            <Text as="h2" variant="headingLg" fontWeight="semibold">
              {lng.EnableTitle || 'Enable WiserNotify in Shopify'}
            </Text>
            <Text variant="bodyMd" tone="subdued">
              {lng.EnableDesc || "To display notifications on your store, you'll need to enable the WiserNotify App Embed in your Theme Editor."}
            </Text>
            <Box paddingBlockStart={100}>
              <BlockStack gap={200}>
                <Text variant="bodyMd">1. {lng.EnableStep1 || 'Click on the button below to open a new window.'}</Text>
                <Text variant="bodyMd">2. {lng.EnableStep2 || 'Check if the "WiserNotify" block is enabled.'}</Text>
                <Text variant="bodyMd">3. {lng.EnableStep3Prefix || 'Click'} <strong>{lng.EnableStep3Bold || 'Save'}</strong>{lng.EnableStep3Suffix || ', return here and click Continue'}</Text>
              </BlockStack>
            </Box>
            <Box paddingBlockStart={300}>
              <Button variant="primary" icon={ExternalIcon} url={embedUrl} target="_blank">
                {lng.EnableAppEmbed || 'Enable app embed'}
              </Button>
            </Box>
            <div className="shopify-onboard-help-strip">
              <span>&#x1F4AC;</span>
              <span>
                {lng.NeedHelp || 'Need help?'}{' '}
                <a href="#" onClick={(e) => { e.preventDefault(); if (window.Froged) window.Froged('open'); }}>
                  {lng.LiveChat || 'Chat with us'}
                </a>
                {' '}{lng.Or || 'or'}{' '}
                <a href="mailto:support@wisernotify.com">
                  {lng.EmailUs || 'email us'}
                </a>
              </span>
            </div>
          </BlockStack>
        </div>
      </div>
    </div>
  );
}

export default ShopifyOnboardStep2;
